import { render, staticRenderFns } from "./notice.vue?vue&type=template&id=537f9f1b&scoped=true"
import script from "./notice.vue?vue&type=script&lang=ts"
export * from "./notice.vue?vue&type=script&lang=ts"
import style0 from "./notice.vue?vue&type=style&index=0&id=537f9f1b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "537f9f1b",
  null
  
)

export default component.exports